var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{class:{blur:!_vm.project}},[_c('Navbar'),_c('router-view')],1),(!_vm.project && _vm.isMounted)?_c('div',{staticClass:"mask"},[_c('div',{staticClass:"message"},[_vm._v("缺少参数: project")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }